/* @flow */
/**
 * Possible settings:
 *  chargeDeliveryFeeOnFree - bool
 */

let initialState: {} = {};
export function settings(state: Object = initialState, action:Object) {
    if(action.type === "FETCH_EVENT") {
        let newState = {...state};
        newState = {...action.data.attributes.settings};
        return newState;
    } else {
        return state;
    }
}
